import axios, { AxiosResponse } from "axios";
import type { Role } from "./Role";

const ROLE_API = "/management/roles";

const getRole = async (id:number):Promise<AxiosResponse<Role>> => {
  return axios.get<Role>(`${ROLE_API}/${id}`)
}

export { getRole, ROLE_API }